import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PartyInterface } from '@app/core/interfaces/party.interface';
import { PersonInterface } from '@app/core/interfaces/person/person.interface';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { NewModal } from 'outshared-lib';
import { AddPartyModalComponent } from '@app/my-zone/shared/involved-parties/party/add-party-modal/add-party-modal.component';
import { PartyRolesEnum } from '@app/core';

@Component({
    selector: 'ins-party',
    templateUrl: './party.component.html',
    styleUrls: ['./party.component.scss'],
})
export class PartyComponent implements OnInit {
    @Input() showContent: boolean = false;
    @Input() fileSerialNumber: number;
    @Input() relationId: number;
    @Input() party: PartyInterface;

    @Output() readonly opened: EventEmitter<string> = new EventEmitter();
    @Output() readonly closed: EventEmitter<string> = new EventEmitter();

    public allowAdd: boolean;
    public addDriver: boolean = false;
    public persons: PersonInterface[] = [];
    public role: string;
    public partyRoles: typeof PartyRolesEnum = PartyRolesEnum;
    public counterPartySerialNumber: number;
    public addressRelationId: number;

    constructor(private scrollService: ScrollService, private modalService: NewModal) {}

    ngOnInit(): void {
        this.persons = this.party.personen;
        this.role = this.party.rol;
        this.allowAdd = this.party.toevoegen_toestaan;
    }

    public toggle(): boolean {
        this.modalService.open(AddPartyModalComponent, {data: this});
        this.opened.emit(this.role);

        this.scrollService.scrollElementOffset(`#partij_${this.role.toLowerCase()}`);

        return false;
    }

    public toggleDriver(counterPartySerialNumber?: number, addressRelationId?: number): boolean {
        this.addDriver = true;

        if (this.addDriver && !this.showContent) {
            if (counterPartySerialNumber && addressRelationId) {
                this.counterPartySerialNumber = counterPartySerialNumber;
                this.addressRelationId = addressRelationId;
            }
            this.showContent = true;
            this.opened.emit(this.role);
        } else {
            this.showContent = false;
            this.closed.emit();
        }

        this.scrollService.scrollElementOffset(`#partij_${this.role.toLowerCase()}`);

        return false;
    }
}
